// removed by extract-text-webpack-plugin
module.exports = {"previewVsm":"_1F3H-yLJ9T-P-cGzNfhuAv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/components/VerticalSectionMarker/constants/verticalSectionMarkerSet.css
// module id = 1351
// module chunks = 0